export default {
  N02b_SDKP_DVDT_ND112020: 'N02b_SDKP_DVDT_ND112020',
};
